export default __webpack_public_path__ + "static/media/project_lg_autopartes_1.64560a23.png";